(() => {
  'use strict';
  if (window.BandenmeestersDisplayLabels) return;

  // Customer-facing casing only. Canonical manufacturer identities, SKU codes,
  // product handles, fitment evidence and SEO records are never rewritten.
  const keepUppercase = new Set([
    'BMW', 'BBS', 'OZ', 'VW', 'AMG', 'OEM', 'TPMS', 'ABS', 'ET',
    'PCD', 'CB', 'DOT', 'MINI', 'SUV', 'EV', 'EU', 'BE', 'NL',
    'SK', 'BV', 'HLT', 'RFT', 'KBA', 'ECE', 'TÜV', 'AEZ',
    'ATS', 'DOTZ', 'MAK', 'CMS', 'RS', 'GT', 'JR', 'CI',
    'SSR', 'UHP', 'RF', 'JWL', 'VIA', 'XL', 'B2B', 'FAQ',
    'APK', 'BTW', 'ISO', 'MBLP'
  ]);

  const format = value => String(value ?? '').replace(
    /(?<![\p{L}\p{N}])\p{Lu}{2,}(?![\p{L}\p{N}])/gu,
    word => keepUppercase.has(word) ? word : word.charAt(0) + word.slice(1).toLocaleLowerCase('nl-NL')
  );

  const selectors = [
    '.bm-new-card__title a',
    '.bm-new-card__manufacturer [data-bm-new-maker-text]',
    '.bm-new-product__title',
    '.bm-new-product__manufacturer-link',
    '.bm-new-product__manufacturer [data-bm-new-manufacturer]',
    '.bm-new-product__brand-story h2',
    '.bm-new-product__brand-story p',
    '.bm-new-results--wheel-hub .bm-new-results__heading',
    '.bm-new-results--wheel-hub .bm-new-wheel-hub__intro',
    '.bm-new-results--wheel-hub .bm-new-results__context [aria-current="page"]'
  ];
  const applyTo = scope => {
    for (const selector of selectors) {
      scope.querySelectorAll(selector).forEach(element => {
        if (element.children.length) return;
        const current = element.textContent;
        const display = format(current);
        if (current !== display) element.textContent = display;
      });
    }
  };

  window.BandenmeestersDisplayLabels = Object.freeze({ format, applyTo });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyTo(document), { once: true });
  } else applyTo(document);
  document.addEventListener('shopify:section:load', event => applyTo(event.target));
})();